<template>
    <v-card max-width=600 :to="cat.link">
        <div class="d-flex flex-no-wrap justify-space-between">
            <div>
                <v-card-title class="text-h5">
                    {{ cat.name }}
                </v-card-title>

                <v-card-subtitle>{{ cat.birthday.getUTCDate() }}. {{ cat.birthday.toLocaleString('default', {
                    month: 'long'
                }) }} {{ cat.birthday.getUTCFullYear() }}</v-card-subtitle>
                <v-card-subtitle>{{ cat.color }}</v-card-subtitle>
            </div>

            <v-avatar class="ma-3" size="125" rounded="0">
                <v-img :lazy-src="profileImageThumbLink(cat['id'])" :src="profileImageLink(cat['id'])"></v-img>
            </v-avatar>
        </div>
    </v-card>
</template>

<script>
export default {
    setup() {
    },
    data() {
        return {}
    },
    mounted() {
    },
    methods: {
        profileImageThumbLink(catname) {
            if (process.env.NODE_ENV === 'development') {
                return require("@/assets/static/katzendetails/thumb." + catname + ".png");
            } else {
                return "https://static.jokingheroes.de/katzendetails/thumb." + catname + ".png";
            }
        },
        profileImageLink(catname) {
            if (process.env.NODE_ENV === 'development') {
                return require("@/assets/static/katzendetails/" + catname + ".png");
            } else {
                return "https://static.jokingheroes.de/katzendetails/" + catname + ".png";
            }
        }
    },
    props: [
        'cat',
    ],
}
</script>
